(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yc-card"] && !Shopify.designMode) return;
  try {
    /* Pellicule des cartes produit (maquette 9C3, client 09/10/2026).
     Ordinateur : la position de la souris dans la carte choisit la photo
     (3 au plus), qui glisse comme une pellicule ; une barre en segments et un
     compteur disent ou on en est.
     Telephone : on balaie la photo du doigt (le defilement vertical de la page
     reste libre). Les photos sont deja dans la page (balises img lues par
     Google) ; on ne fait que les deplacer. Rien ne se passe au chargement :
     tout part du premier survol ou du premier toucher. */
  (function () {
    if (window.ycPellicule) return;
    window.ycPellicule = true;
    var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var etats = new WeakMap(), prets = [], actifs = [], boucle = 0;

    function borne(v, a, b) { return Math.max(a, Math.min(b, v)); }

    function etat(media) {
      var s = etats.get(media);
      if (s) return s;
      var pel = media.querySelector('.yc-pel');
      if (!pel) return null;
      var imgs = [].slice.call(pel.querySelectorAll('.yc-pel__img'));
      var base = null;
      for (var i = 0; i < media.children.length; i++) {
        var c = media.children[i];
        if (c.tagName === 'IMG' || (c.classList && c.classList.contains('yc-card__suggestion-image'))) { base = c; break; }
      }
      s = { media: media, pel: pel, imgs: imgs, base: base, n: imgs.length + 1, prog: 0, pos: 0,
            x0: 0, parti: false, retour: 0, bouge: 0, tire: null, glisse: false, dedans: false, pret: false };
      etats.set(media, s);
      return s;
    }

    function mesurer(s) {
      var st = getComputedStyle(s.media);
      var pad = parseFloat(st.paddingLeft) || 0;
      s.W = s.media.clientWidth;
      s.pel.style.top = s.pel.style.bottom = pad + 'px';
      s.pel.style.left = s.pel.style.right = pad + 'px';
      s.imgs.forEach(function (im, j) { im.style.left = ((j + 1) * s.W) + 'px'; });
    }

    function rendu(s) {
      var t = 'translateX(' + (-s.pos * s.W).toFixed(1) + 'px)';
      s.pel.style.transform = t;
      if (s.base) s.base.style.transform = t;
      for (var j = 0; j < s.barres.length; j++) {
        s.barres[j].style.transform = 'scaleX(' + borne(s.pos - j + 1, 0, 1).toFixed(3) + ')';
      }
      s.cpt.textContent = (Math.round(s.pos) + 1) + ' / ' + s.n;
    }

    function preparer(s) {
      if (s.pret) return;
      s.pret = true;
      /* Premier survol : les autres photos se chargent maintenant. */
      s.imgs.forEach(function (im) {
        if (im.tagName === 'IMG') im.loading = 'eager';
        else if (im.getAttribute('data-yc-fond')) im.style.backgroundImage = 'url("' + im.getAttribute('data-yc-fond') + '")';
      });
      var segs = document.createElement('span');
      segs.className = 'yc-pel__segs';
      segs.setAttribute('aria-hidden', 'true');
      for (var i = 0; i < s.n; i++) segs.appendChild(document.createElement('i')).appendChild(document.createElement('b'));
      var cpt = document.createElement('span');
      cpt.className = 'yc-pel__cpt';
      cpt.setAttribute('aria-hidden', 'true');
      s.media.appendChild(segs);
      s.media.appendChild(cpt);
      s.barres = [].slice.call(segs.querySelectorAll('b'));
      s.cpt = cpt;
      prets.push(s);
      mesurer(s);
      rendu(s);
    }

    function activer(s) {
      s.media.classList.add('is-actif');
      if (actifs.indexOf(s) < 0) actifs.push(s);
      if (!boucle) boucle = requestAnimationFrame(tic);
    }

    function tic(now) {
      boucle = 0;
      actifs = actifs.filter(function (s) {
        /* Au repos (souris immobile, doigt leve), on se cale sur une photo. */
        if (!s.tire && now - s.bouge > 220) s.prog = Math.round(s.prog);
        var d = s.prog - s.pos;
        if (Math.abs(d) > 0.002) {
          s.pos += reduit ? d : d * 0.16;
          rendu(s);
          return true;
        }
        if (s.pos !== s.prog) { s.pos = s.prog; rendu(s); }
        if (s.tire) return true;
        /* Photo calee : la boucle s'arrete (le prochain geste la relance). */
        if (!s.dedans && s.prog === 0) s.media.classList.remove('is-actif');
        return false;
      });
      if (actifs.length) boucle = requestAnimationFrame(tic);
    }

    function mediaDe(cible) {
      var carte = cible && cible.closest ? cible.closest('.yc-card') : null;
      return carte ? carte.querySelector('.yc-card__media--pel') : null;
    }

    /* Ordinateur : la POSITION du curseur dans la carte choisit la photo
       (client, 09/10/2026). Tiers gauche = photo 1, milieu = photo 2, tiers
       droit = photo 3, avec une marge de 10 % de chaque cote : on atteint la
       derniere photo avant de sortir, d'ou qu'on soit entre. Avant, la photo
       suivait le DEPLACEMENT depuis le point d'entree : entre au milieu, on
       sortait de la carte avant la derniere photo. */
    document.addEventListener('pointerover', function (e) {
      if (e.pointerType !== 'mouse') return;
      var media = mediaDe(e.target), s = media && etat(media);
      if (!s || s.dedans) return;
      s.dedans = true;
      s.x0 = e.clientX;
      s.parti = false;
      clearTimeout(s.retour);
      preparer(s);
      activer(s);
    }, { passive: true });

    /* En sortant, la photo affichee reste (elle finit de se caler), puis
       revient doucement a la premiere au bout de 2,5 s. */
    document.addEventListener('pointerout', function (e) {
      if (e.pointerType !== 'mouse') return;
      var media = mediaDe(e.target), s = media && etats.get(media);
      if (!s || !s.dedans) return;
      var carte = media.closest('.yc-card');
      if (e.relatedTarget && carte.contains(e.relatedTarget)) return;
      s.dedans = false;
      clearTimeout(s.retour);
      s.retour = setTimeout(function () {
        if (s.dedans) return;
        s.prog = 0;
        activer(s);
      }, 2500);
      activer(s);
    }, { passive: true });

    /* Un glisser-deposer de l'image n'a pas de sens ici : un clic ouvre la fiche. */
    document.addEventListener('dragstart', function (e) {
      if (e.target.closest && e.target.closest('.yc-card__media--pel')) e.preventDefault();
    });

    document.addEventListener('pointermove', function (e) {
      var media, s;
      if (e.pointerType === 'mouse') {
        media = mediaDe(e.target);
        s = media && etats.get(media);
        if (!s || !s.dedans) return;
        /* La photo ne change qu'une fois la souris vraiment en mouvement : on ne
           saute pas a la photo 3 en entrant par la droite. */
        if (!s.parti) {
          if (Math.abs(e.clientX - s.x0) < 6) return;
          s.parti = true;
        }
        var r = media.closest('.yc-card').getBoundingClientRect(), marge = r.width * 0.1;
        var f = (e.clientX - r.left - marge) / Math.max(1, r.width - 2 * marge);
        s.prog = borne(Math.floor(borne(f, 0, 0.9999) * s.n), 0, s.n - 1);
        s.bouge = performance.now();
        activer(s);
        return;
      }
      for (var i = 0; i < actifs.length; i++) {
        s = actifs[i];
        if (!s.tire || s.tire.id !== e.pointerId) continue;
        var ecart = e.clientX - s.tire.x;
        if (Math.abs(ecart) > 6) s.glisse = true;
        s.prog = borne(s.tire.p - ecart / (s.W * 0.7), 0, s.n - 1);
        s.bouge = performance.now();
      }
    }, { passive: true });

    /* Telephone : on balaie la photo du doigt. */
    document.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') return;
      var media = e.target.closest && e.target.closest('.yc-card__media--pel');
      var s = media && etat(media);
      if (!s) return;
      preparer(s);
      s.tire = { id: e.pointerId, x: e.clientX, p: s.prog };
      s.glisse = false;
      activer(s);
    }, { passive: true });

    function lacher(e) {
      actifs.forEach(function (s) {
        if (s.tire && s.tire.id === e.pointerId) { s.tire = null; s.prog = Math.round(s.prog); }
      });
    }
    document.addEventListener('pointerup', lacher, { passive: true });
    document.addEventListener('pointercancel', lacher, { passive: true });

    /* Un balayage n'est pas un clic : on ne quitte pas la page apres avoir fait
       defiler les photos. */
    document.addEventListener('click', function (e) {
      var media = e.target.closest && e.target.closest('.yc-card__media--pel');
      var s = media && etats.get(media);
      if (s && s.glisse) { e.preventDefault(); e.stopPropagation(); s.glisse = false; }
    }, true);

    var minuteur;
    window.addEventListener('resize', function () {
      clearTimeout(minuteur);
      minuteur = setTimeout(function () { prets.forEach(function (s) { mesurer(s); rendu(s); }); }, 150);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
